import { render, staticRenderFns } from "./DialogLayout.vue?vue&type=template&id=536ff174"
import script from "./DialogLayout.vue?vue&type=script&lang=js"
export * from "./DialogLayout.vue?vue&type=script&lang=js"
import style0 from "./DialogLayout.vue?vue&type=style&index=0&id=536ff174&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports